// this module provides you with all defined routes.

import { matchPath } from 'react-router-dom'
import namedRoutes from '../../config/routes'

function namedRoute(name) {
  return namedRoutes[name]
}

function generatePathByRouteName(name, params = {}, type = 'path') {
  const namedRoutePath = namedRoute(name)[type] ? namedRoute(name)[type] : namedRoute(name)['path']
  let ret = namedRoutePath.replace(/(:[^\\?]+\??)/g, (fullPattern, match) => {
    const paramName = match.replace(/:|\?/g, '')
    return params[paramName] || ''
  })

  if (ret.charAt(ret.length - 1) === '/') {
    ret = ret.slice(0, -1)
  }

  return ret
}

const currentRouteName = (location) =>
  Object.keys(namedRoutes).find((key) => matchPath(location.pathname, { ...namedRoutes[key] }))

const currentRoute = (location) => namedRoutes[currentRoute(location)]

export { namedRoute, generatePathByRouteName, currentRoute, currentRouteName, namedRoutes }
